/**
 * Route guards. RequireAuth redirects to /login when no user is signed in.
 * RequireAdmin additionally requires role === 'admin'.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

function FullPageLoader(): JSX.Element {
  return (
    <div className="min-h-screen grid place-items-center bg-ink-950 text-cream-400 text-sm font-arcade tracking-widest">
      LOADING…
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader />;
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }): JSX.Element {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (user === null) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') {
    return (
      <div className="min-h-[60vh] grid place-items-center px-5">
        <div className="text-center">
          <div className="text-6xl mb-3">🔒</div>
          <div className="font-display text-xl text-white font-bold">需要管理员权限</div>
          <div className="mt-2 text-sm text-cream-400">此页面只有 admin 角色能进。</div>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
